/**
 * 用于存储app的各种全局状态,如:
 * > 当前是否正在进行路由切换(以用于显示一个加载的效果)
 * > 下一个页面切换的方向(用以实现页面切换动画)
 * > 列表页面的滚动条位置等
 */
import {ROUTE_SWITCHING, SHOW_PERSONINDEX, REQUIRE_HEADER} from '../mutation'

const state = {
  isSwitching: false,   // 路由正在切换...
  personindex: false,
  accountId: null,
  isCb: true
}

const mutations = {
  [ROUTE_SWITCHING] (state, isSwitching) {
    state.isSwitching = isSwitching
  },
  [SHOW_PERSONINDEX] (state, id) {
    state.personindex = !state.personindex
    state.accountId = id
  },
  [REQUIRE_HEADER] (state) {
    state.isCb = !state.isCb
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/app.js